import { render, staticRenderFns } from "./DadataInput.vue?vue&type=template&id=2fbee86a&scoped=true&"
import script from "./DadataInput.vue?vue&type=script&lang=js&"
export * from "./DadataInput.vue?vue&type=script&lang=js&"
import style0 from "./DadataInput.vue?vue&type=style&index=0&id=2fbee86a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbee86a",
  null
  
)

export default component.exports